define("shared/utils/formatters/ig-user-from-basic-display", ["exports", "later/models/ig-post"], function (_exports, _igPost) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"later/models/ig-post"eaimeta@70e063a35619d71f

  const createIgUserFromBasicDisplay = (_ref, socialProfile) => {
    let {
      id,
      username,
      account_type: accountType,
      media_count: mediaCount
    } = _ref;
    const user = {
      id,
      username,
      accountType,
      mediaCount
    };
    user.socialProfile = socialProfile;
    return _igPost.default.create(user);
  };

  var _default = createIgUserFromBasicDisplay;
  _exports.default = _default;
});